module.exports = __webpack_public_path__ + "static/index-8c3743619ae2e3b1b38ee123532fe91a.jpg";